export default "__VITE_ASSET__8106a0da__"